module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [(_vm.responseMessage.modal) ? _c('v-dialog', {
    attrs: {
      "value": _vm.responseMessage.show,
      "persistent": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.responseMessage, "show", $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline white--text",
    class: _vm.responseMessage.type
  }, [_vm._v(_vm._s(_vm.responseMessage.title))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.responseMessage.text))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": _vm.responseMessage.type,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ok')))])], 1)], 1)], 1) : _c('v-snackbar', {
    attrs: {
      "top": "",
      "color": _vm.responseMessage.type
    },
    model: {
      value: (_vm.responseMessage.show),
      callback: function($$v) {
        _vm.$set(_vm.responseMessage, "show", $$v)
      },
      expression: "responseMessage.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.responseMessage.text) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93f840ce","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackMessage.vue
// module id = AJMs
// module chunks = 1